<div class="dialog-content flex flex-col h-[90vh] max-h-[90vh]">
  <div class="relative p-5 w-full bg-white dark:bg-gray-800 flex-none border-b border-gray-200 dark:border-gray-700">
    <div class="flex justify-between items-center">
      <h3 class="text-lg font-medium text-gray-900 dark:text-white" data-testid="ocr-dialog-title">OCR Document Testing</h3>
      <div class="flex items-center space-x-2">
        <label for="ocr-file-upload-more" data-testid="ocr-dialog-add-document-btn" class="cursor-pointer inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200">
          <svg class="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path></svg>
          Add Document
        </label>
        <input id="ocr-file-upload-more" data-testid="ocr-dialog-file-input-more" type="file" class="hidden" (change)="onFileSelected($event)" [accept]="accept" multiple>

        <button data-testid="ocr-dialog-close-x-btn" (click)="closeDialog()" class="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
        </button>
      </div>
    </div>
  </div>

  <div class="flex-grow overflow-y-auto p-5 bg-gray-50 dark:bg-gray-900">
    @if (documents.length === 0) {
      <div class="flex flex-col items-center justify-center h-full border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 p-10">
        <svg class="w-16 h-16 text-gray-400 dark:text-gray-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-4-4V6a4 4 0 014-4h10a4 4 0 014 4v6a4 4 0 01-4 4H7z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 16v2a2 2 0 01-2 2H10a2 2 0 01-2-2v-2m2-10V4M12 16v-4m-4 0h8"></path></svg>
        <label for="ocr-file-upload" data-testid="ocr-dialog-select-files-btn" class="cursor-pointer bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200 shadow-md">
          Select Files
        </label>
        <input id="ocr-file-upload" data-testid="ocr-dialog-file-input" type="file" class="hidden" (change)="onFileSelected($event)" [accept]="accept" multiple>
        <p class="mt-4 text-gray-500 dark:text-gray-400 text-center" data-testid="ocr-dialog-supported-formats">Select one or more {{ supportedFormats }} files to start testing OCR extraction.</p>
      </div>
    }

    <div class="space-y-12">
      @for (doc of documents; track doc; let i = $index) {
        <div class="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
          <!-- Document Header -->
          <div class="px-4 py-3 bg-gray-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600 flex justify-between items-center">
            <div class="flex items-center">
              <span class="bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 text-xs font-bold px-2 py-1 rounded mr-3">#{{i + 1}}</span>
              <h4 class="text-sm font-bold text-gray-800 dark:text-gray-200 truncate max-w-md">{{ doc.file.name }}</h4>
            </div>
            <div class="flex items-center space-x-2">
              <button
                data-testid="ocr-dialog-start-ocr-btn"
                (click)="startOcrProcessing(i)"
                [disabled]="doc.isProcessing || !doc.accepted"
                class="inline-flex items-center px-3 py-1 text-xs font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 transition-colors duration-200"
              >
                @if (doc.isProcessing) {
                  <svg class="animate-spin -ml-1 mr-2 h-3 w-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                  Processing...
                } @else {
                  <span>{{ doc.extractedData ? 'Re-process' : 'Start OCR' }}</span>
                }
              </button>
              <button data-testid="ocr-dialog-remove-document-btn" (click)="removeDocument(i)" class="text-gray-400 dark:text-gray-500 hover:text-red-500 dark:hover:text-red-400 transition-colors duration-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
              </button>
            </div>
          </div>

          <!-- Document Content -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-0 h-[60vh]">
            <!-- Original Preview -->
            <div class="border-r border-gray-200 dark:border-gray-700 flex flex-col bg-gray-100 dark:bg-gray-900">
              <div class="flex-grow relative">
                @if (doc.accepted && doc.previewKind === 'download') {
                  <div
                    class="flex h-full flex-col items-center justify-center gap-3 p-6 text-center"
                    data-testid="ocr-dialog-file-preview">
                    <svg class="w-16 h-16 text-gray-400 dark:text-gray-500" aria-hidden="true" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                    <p class="text-sm font-medium text-gray-800 dark:text-gray-200 break-all">{{ doc.file.name }}</p>
                    <p class="text-xs text-gray-600 dark:text-gray-400">No preview for this file type. It is converted to Markdown for extraction.</p>
                  </div>
                } @else if (doc.previewUrl) {
                  @if (doc.previewKind === 'image') {
                    <div class="absolute inset-0 overflow-auto">
                      <img
                        [src]="doc.previewUrl"
                        [alt]="'Preview of ' + doc.file.name"
                        class="mx-auto block max-w-full h-auto"
                        data-testid="ocr-dialog-image-preview"
                        (error)="onImagePreviewError(doc)">
                    </div>
                  } @else {
                    <iframe [src]="doc.previewUrl" class="w-full h-full border-0" data-testid="ocr-dialog-pdf-preview"></iframe>
                  }
                } @else if (doc.errorMessage && !doc.previewUrl) {
                  <div class="flex items-center justify-center h-full text-red-500 p-4 text-center">
                    {{ doc.errorMessage }}
                  </div>
                } @else {
                  <div class="flex items-center justify-center h-full text-gray-500 dark:text-gray-400">
                    Loading preview...
                  </div>
                }
              </div>
            </div>

            <!-- Extracted Data -->
            <div class="flex flex-col bg-white dark:bg-gray-800 overflow-auto relative">
              @if (doc.errorMessage && doc.extractedData) {
                <div class="m-4 p-3 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 text-xs rounded-md border border-red-100 dark:border-red-800">
                  {{ doc.errorMessage }}
                </div>
              }

              @if (doc.extractedData) {
                <div class="p-4">
                  <app-ocr-result [metadata]="doc.extractedData"></app-ocr-result>
                </div>
              } @else if (doc.isProcessing) {
                <div class="flex flex-col items-center justify-center h-full text-gray-500 dark:text-gray-400 space-y-4 px-8">
                  @if (doc.phase === 'queued') {
                    <div class="animate-pulse rounded-full h-10 w-10 bg-gray-300 dark:bg-gray-600"></div>
                    <p class="text-sm font-medium">Waiting to upload…</p>
                  } @else if (doc.phase === 'uploading') {
                    <p class="text-sm font-medium">
                      {{ doc.uploadProgress < 100 ? 'Uploading document…' : 'Finalizing upload…' }}
                    </p>
                    <div class="w-full bg-zinc-200 rounded-full h-1.5 dark:bg-zinc-700" data-testid="ocr-dialog-upload-progress">
                      <div class="bg-blue-600 h-1.5 rounded-full transition-all" [style.width.%]="doc.uploadProgress"></div>
                    </div>
                    <p class="text-xs">{{ doc.uploadProgress }}%</p>
                  } @else {
                    <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
                    <p class="text-sm font-medium">Extracting data from document...</p>
                  }
                </div>
              } @else if (doc.errorMessage && !doc.extractedData) {
                <div class="flex flex-col items-center justify-center h-full p-6 text-center">
                  <svg class="w-12 h-12 text-red-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                  <p class="text-red-500 font-medium">{{ doc.errorMessage }}</p>
                  <button data-testid="ocr-dialog-retry-btn" (click)="startOcrProcessing(i)" class="mt-4 text-blue-600 hover:underline text-sm font-bold">Try again</button>
                </div>
              } @else {
                <div class="flex items-center justify-center h-full text-gray-400 dark:text-gray-500 p-6 text-center">
                  <div>
                    <svg class="w-12 h-12 mx-auto mb-3 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path></svg>
                    <p>Ready to process document</p>
                    <button data-testid="ocr-dialog-start-ocr-ready-btn" (click)="startOcrProcessing(i)" class="mt-4 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 px-4 py-2 rounded-md text-sm font-bold transition-colors duration-200">Start OCR</button>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      @if (documents.length > 0) {
        <div class="flex justify-center pb-10">
          <label for="ocr-file-upload-bottom" class="group cursor-pointer flex flex-col items-center p-6 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl hover:border-blue-500 dark:hover:border-blue-400 transition-all duration-200 bg-white dark:bg-gray-800 w-full max-w-md">
            <div class="bg-blue-50 dark:bg-blue-900/30 p-3 rounded-full group-hover:bg-blue-100 dark:group-hover:bg-blue-900/50 transition-colors duration-200">
              <svg class="w-8 h-8 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path></svg>
            </div>
            <span class="mt-2 text-sm font-bold text-gray-700 dark:text-gray-300">Add another document</span>
          </label>
          <input id="ocr-file-upload-bottom" data-testid="ocr-dialog-file-input-bottom" type="file" class="hidden" (change)="onFileSelected($event)" [accept]="accept" multiple>
        </div>
      }
    </div>
  </div>

  <div class="p-5 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 flex justify-between items-center flex-none">
    <div class="text-sm text-gray-500 dark:text-gray-400">
      {{ documents.length }} document(s) selected
    </div>
    <div class="flex space-x-3">
      @if (documents.length > 0) {
        <button data-testid="ocr-dialog-clear-all-btn" (click)="clearAll()" class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-md transition-colors duration-200">
          Clear All
        </button>
        <button
          data-testid="ocr-dialog-process-all-btn"
          (click)="startAllOcrProcessing()"
          [disabled]="documents.length === 0"
          class="px-6 py-2 text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 disabled:opacity-50"
        >
          Process All
        </button>
      }
      <button data-testid="ocr-dialog-close-btn" (click)="closeDialog()" class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200">
        Close
      </button>
    </div>
  </div>
</div>
